import { render, staticRenderFns } from "./StorageHeatMap.vue?vue&type=template&id=f9230d8a&scoped=true"
import script from "./StorageHeatMap.vue?vue&type=script&lang=js"
export * from "./StorageHeatMap.vue?vue&type=script&lang=js"
import style0 from "./StorageHeatMap.vue?vue&type=style&index=0&id=f9230d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9230d8a",
  null
  
)

export default component.exports